module.exports = __webpack_public_path__ + "img/banner.98c561c9.png";